import React, { useEffect } from 'react';
import Cookies from 'universal-cookie';

import { getConfig } from '@edx/frontend-platform';

function addPlugins(config, slot_name, plugins) {
  if (slot_name in config.pluginSlots === false) {
    config.pluginSlots[slot_name] = {
      keepDefault: true,
      plugins: []
    };
  }

  config.pluginSlots[slot_name].plugins.push(...plugins);
}
// ===== Alkemy brand v9 — module-scope inject (applies even when FPF import fails, e.g. authn) =====
(function(){
  var akAppId = process.env.APP_ID;
  var akStudio = (akAppId === 'authoring' || akAppId === 'ora-grading' || akAppId === 'gradebook');
  function akApply(){
    if (typeof document === 'undefined' || !document.head) return;
    if (document.getElementById('ak-global-style')) return;
    var akApp = process.env.APP_ID;
    var akSkip = (akApp === 'authoring' || akApp === 'ora-grading' || akApp === 'gradebook');
    if (akSkip) return;
    var akStyle = document.createElement('style');
    akStyle.id = 'ak-global-style';
    akStyle.textContent = `
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap');
:root{
  --pgn-color-primary-base:#01357f !important;
  --pgn-color-primary-500:#01357f !important;
  --pgn-color-primary-400:#1f4f97 !important;
  --pgn-color-primary-600:#012a66 !important;
  --pgn-color-primary-700:#01204d !important;
  --pgn-color-primary-300:#4d7ab0 !important;
  --pgn-color-primary-200:#b3c6e0 !important;
  --pgn-color-primary-100:#e8f0fe !important;
  --pgn-color-brand-base:#01357f !important;
  --pgn-color-brand-500:#01357f !important;
  --pgn-color-link-base:#01357f !important;
  --pgn-color-link-hover:#012a66 !important;
}
body, button, input, optgroup, select, textarea{
  font-family:'Inter',-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,Helvetica,Arial,sans-serif !important;
}
a, a:visited{ color:#01357f; }
a:hover{ color:#012a66; }

/* PRIMARY CTA = gold fill, navy text (forced on inner spans/icons) */
.btn-primary, .btn-brand{
  background-color:#ffd500 !important;
  border-color:#ffd500 !important;
  color:#01357f !important;
  font-weight:700 !important;
}
.btn-primary:hover, .btn-primary:focus, .btn-brand:hover, .btn-brand:focus{
  background-color:#f0c800 !important;
  border-color:#f0c800 !important;
  color:#01357f !important;
}
.btn-primary span, .btn-primary *, .btn-brand span, .btn-brand *{ color:#01357f !important; }
.btn-primary svg, .btn-brand svg, .btn-primary .pgn__icon, .btn-brand .pgn__icon{ color:#01357f !important; fill:#01357f !important; }

/* SECONDARY = navy outline */
.btn-outline-primary{ color:#01357f !important; border-color:#01357f !important; background-color:transparent !important; }
.btn-outline-primary:hover{ background-color:#01357f !important; color:#ffffff !important; }
.btn-tertiary, .btn-link{ color:#01357f !important; background:transparent !important; }

/* HEADER consistent navy + WHITE text (forced on nav links, help, username, dropdown) */
header.bg-primary, .site-header-desktop, .site-header-mobile, .learning-header,
.navbar.bg-primary, .bg-primary{ background-color:#01357f !important; }
header.bg-primary a, header.bg-primary a:visited, .site-header-desktop a, .site-header-desktop a:visited,
.learning-header a, .learning-header span, .bg-primary .nav-link, .bg-primary h1, .bg-primary h2,
.bg-primary span, .bg-dark a,
header.bg-primary .nav-link, header.bg-primary button, header.bg-primary .btn-link,
header.bg-primary .dropdown-toggle, .site-header-desktop .nav-link, .site-header-desktop button,
.site-header-desktop .dropdown-toggle, .site-header-desktop svg{ color:#ffffff !important; fill:#ffffff !important; }
header.bg-primary .dropdown-toggle span, .site-header-desktop .dropdown-toggle span{ color:#ffffff !important; }

/* FIX #3: dropdown MENUS render on a white surface — undo the header white-text
   bleed so items aren't white-on-white. Higher-specificity selectors (incl. the
   header-scoped ones) guarantee these win over the navy-header white-text rules. */
.dropdown-menu, .dropdown-menu span, .dropdown-menu a, .dropdown-menu a:visited,
.dropdown-menu .dropdown-item, .dropdown-menu button, .dropdown-menu .btn-link,
.dropdown-menu svg, .pgn__menu a, .pgn__menu span, [role="menu"] a, [role="menu"] span,
.bg-primary .dropdown-menu a, .bg-primary .dropdown-menu span, .bg-primary .dropdown-menu .dropdown-item,
header.bg-primary .dropdown-menu a, header.bg-primary .dropdown-menu span,
.site-header-desktop .dropdown-menu a, .site-header-desktop .dropdown-menu span{
  color:#01357f !important;
  fill:#01357f !important;
}
.dropdown-menu, .pgn__menu, [role="menu"]{ background-color:#ffffff !important; }
.dropdown-menu .dropdown-item:hover, .dropdown-menu a:hover,
.pgn__menu a:hover, [role="menu"] a:hover{ background-color:#e8f0fe !important; color:#01357f !important; }
/* FIX #B1: selected/active dropdown item — Paragon paints .active with a navy bg
   while FIX #3 forces item text navy = navy-on-navy (invisible). Force a readable
   selected state: navy bg + WHITE text + gold left accent. Higher specificity
   (.dropdown-menu .dropdown-item.active = 0,3,0) beats FIX #3's item color (0,2,0). */
.dropdown-menu .dropdown-item.active, .dropdown-menu .pgn__dropdown-item.active,
.dropdown-menu .dropdown-item.active span, .dropdown-menu .pgn__dropdown-item.active span,
.dropdown-menu .dropdown-item:active, [role="menu"] [role="menuitem"][aria-selected="true"]{
  background-color:#01357f !important;
  color:#ffffff !important;
  fill:#ffffff !important;
  box-shadow:inset 3px 0 0 #ffd500 !important;
}
.dropdown-menu .dropdown-item.active:hover, .dropdown-menu .pgn__dropdown-item.active:hover{
  background-color:#012a66 !important; color:#ffffff !important;
}

/* FIX #B2: course-outline sidebar (learning MFE) — brand the active section/unit
   + status icons. Real DOM: active section card = .pgn_collapsible.active-section
   (white, faint border); current unit row = li.bg-info-100 (near-Frost, no accent);
   completed icon = svg.text-success (green). Target: navy #01357f, gold #ffd500,
   Frost #F5F6FA. Scoped to sidebar structure so MFE-wide utilities are untouched. */
.pgn_collapsible.active-section{ box-shadow:inset 3px 0 0 #01357f !important; border-color:#01357f !important; }
.collapsible-body .list-unstyled li.bg-info-100{ background-color:#F5F6FA !important; box-shadow:inset 3px 0 0 #ffd500 !important; }
.collapsible-body .list-unstyled li.bg-info-100 a{ color:#01357f !important; font-weight:600 !important; }
.pgn_collapsible .text-success, .pgn_collapsible svg.text-success{ color:#01357f !important; }
/* FIX #B2c (2026-07-02): the outline-tray heading ("Live Class Session Week 01 · 2 sessions")
   is .outline-sidebar-heading-wrapper carrying Paragon .bg-light = rgb(248,247,246) — the last
   off-brand beige in the sidebar. Live audit: it's the ONLY bg-light in the whole sequence tray;
   section triggers are transparent + cards white, so this one selector = zero mismatched rows.
   Treatment A (user pick): navy #01357f bg, white title + white back-chevron + white collapse glyph
   (transparent icon-button bg so glyphs stay glyphs, not discs). Matches the global navy header. */
.outline-sidebar-heading-wrapper{ background-color:#01357f !important; }
.outline-sidebar-heading-wrapper, .outline-sidebar-heading-wrapper .outline-sidebar-heading,
.outline-sidebar-heading-wrapper span{ color:#ffffff !important; }
.outline-sidebar-heading-wrapper .btn-icon, .outline-sidebar-heading-wrapper .btn-link{ background-color:transparent !important; }
.outline-sidebar-heading-wrapper svg{ color:#ffffff !important; }
.outline-sidebar-heading-wrapper svg path{ fill:#ffffff !important; }

/* utility buttons on navy bars (NOT gold CTAs) = white fill, navy text */
.bg-primary .btn:not(.btn-primary):not(.btn-brand),
.learning-header .btn:not(.btn-primary):not(.btn-brand),
.instructor-toolbar .btn:not(.btn-primary):not(.btn-brand){
  background-color:#ffffff !important;
  border-color:#ffffff !important;
  color:#01357f !important;
}
.bg-primary .btn:not(.btn-primary):not(.btn-brand):hover,
.learning-header .btn:not(.btn-primary):not(.btn-brand):hover{
  background-color:#e8f0fe !important; color:#01357f !important;
}
.bg-primary .btn:not(.btn-primary):not(.btn-brand) span,
.learning-header .btn:not(.btn-primary):not(.btn-brand) span{ color:#01357f !important; }

/* GOLD HIGHLIGHTS — active tab underline + banner accents */
.nav-tabs .nav-link.active, .nav-link.active{
  color:#01357f !important;
  border:0 !important;
  border-bottom:3px solid #ffd500 !important;
  background:transparent !important;
}
.nav-tabs .nav-link:hover{ border:0 !important; border-bottom:3px solid #ffe98a !important; }
.alert, .pgn__pagebanner{ border-left:4px solid #ffd500 !important; }

/* active toggle pills / segmented buttons = navy fill, white text */
.btn-group .btn.active, .nav-pills .nav-link.active, [role="group"] .btn.active,
.pgn__nav-pills .nav-link.active, .btn-group-toggle .btn.active{
  background-color:#01357f !important; border-color:#01357f !important; color:#ffffff !important;
}
.btn-group .btn.active span, .nav-pills .nav-link.active span,
[role="group"] .btn.active span, .btn-group .btn.active *{ color:#ffffff !important; }

/* status pills (Today etc.) = navy fill, white text */
.badge, .pgn__chip, .pill, [class*="badge-"], .badge-success, .badge-warning, .badge-info{
  background-color:#01357f !important;
  color:#ffffff !important;
  border-color:#01357f !important;
}
.badge span, .pgn__chip span, [class*="badge-"] span{ color:#ffffff !important; }

/* HIDE: footer "Powered by" stub + "Looking for a challenge" promo (real selectors) */
.powered-area{ display:none !important; }
#looking-for-challenge-widget{ display:none !important; }

/* misc */
.progress-bar{ background-color:#01357f !important; }
.badge-primary{ background-color:#01357f !important; color:#ffffff !important; }

/* FIX v10: learner-dashboard navy header contrast regressions (live audit 2026-07-02).
   (a) active .nav-link was navy-on-navy ("Courses" invisible) -> white text, keep gold underline.
   (b) account .menu-trigger was white text on its light #f2f7f8 pill ("zoomhost" invisible) -> navy text on white pill. */
.site-header-desktop .nav-link.active, header.bg-primary .nav-link.active,
.learning-header .nav-link.active, .site-header-mobile .nav-link.active{
  color:#ffffff !important; border-bottom:3px solid #ffd500 !important; background:transparent !important;
}
.site-header-desktop .menu-trigger, .site-header-desktop .menu-trigger span, .site-header-desktop .menu-trigger *,
header.bg-primary .menu-trigger, header.bg-primary .menu-trigger *,
.menu-trigger.btn-outline-primary, .menu-trigger.btn-outline-primary span{
  color:#01357f !important; fill:#01357f !important; background-color:#ffffff !important; border-color:#ffffff !important;
}
.site-header-desktop .menu-trigger:hover, header.bg-primary .menu-trigger:hover{ background-color:#e8f0fe !important; }

/* FIX #5b (v11): Google "Sign in with Google" button — Google OFFICIAL light theme.
   Ref: developers.google.com/identity/branding-guidelines (light neutral button).
   Spec: white bg, 1px #747775 border, #1f1f1f text, Roboto/Inter 500 14px, 40px tall,
   4px radius, subtle shadow, 4-color G left-aligned. This FORCES OFF the navy
   brand-primary button bg AND the authn default .btn-tpa__font-container #15376d tile
   (that navy tile made the G's transparent areas look like a blue "swoosh").
   Bundle span text = just "Google", so prepend "Sign in with " via ::before.
   Asset google-g.png = official 4-color Google G (verified). */
.btn-oa2-google-oauth2, .btn-tpa.btn-oa2-google-oauth2, .btn.btn-social.btn-oa2-google-oauth2{
  background-color:#ffffff !important;
  background-image:none !important;
  border:1px solid #747775 !important;
  border-radius:4px !important;
  color:#1f1f1f !important;
  box-shadow:0 1px 2px 0 rgba(60,64,67,0.30), 0 1px 3px 1px rgba(60,64,67,0.15) !important;
  height:40px !important;
  padding:0 12px !important;
  display:flex !important;
  align-items:center !important;
  justify-content:center !important;
  font-family:'Roboto','Inter',arial,sans-serif !important;
}
.btn-oa2-google-oauth2:hover, .btn-tpa.btn-oa2-google-oauth2:hover,
.btn-oa2-google-oauth2:focus, .btn-tpa.btn-oa2-google-oauth2:focus{
  background-color:#f7f8f8 !important; border-color:#747775 !important; color:#1f1f1f !important;
}
/* icon tile → transparent, 20px, the real 4-color G */
.btn-oa2-google-oauth2 .btn-tpa__font-container, .btn-tpa.btn-oa2-google-oauth2 .btn-tpa__font-container{
  background:url(https://learn.alkemyedtech.com/static/alkemy/images/google-g.png) no-repeat center center !important;
  background-color:transparent !important;
  background-size:contain !important;
  width:20px !important; height:20px !important; min-width:20px !important; padding:0 !important;
  flex:0 0 auto !important;
}
.btn-oa2-google-oauth2 .btn-tpa__font-container > *{ display:none !important; }
/* also handle the img-icon DOM path if icon_image is ever set */
.btn-oa2-google-oauth2 img.btn-tpa__image-icon{
  content:url('https://learn.alkemyedtech.com/static/alkemy/images/google-g.png') !important;
  background-color:transparent !important; max-height:20px !important; max-width:20px !important;
}
/* label → dark, medium; prepend "Sign in with " (bundle span text = just "Google") */
.btn-oa2-google-oauth2 span, .btn-tpa.btn-oa2-google-oauth2 span{
  color:#1f1f1f !important; font-weight:500 !important; font-size:14px !important;
  margin-left:12px !important; letter-spacing:0.25px !important; text-transform:none !important;
}
.btn-oa2-google-oauth2 span::before{ content:"Sign in with "; }

/* FIX #2: logo. LOGO_URL (config.yml) = full-colour logo for light surfaces
   (authn, etc.). Inside the navy header, swap to the white/knockout logo so it
   stays legible on #01357f. Scoped to header containers ONLY. */
header.bg-primary img, .site-header-desktop img, .site-header-mobile img, .learning-header img,
.bg-primary .logo img, header.bg-primary img.d-block, .site-header-desktop img.d-block{
  content:url('https://learn.alkemyedtech.com/static/alkemy/images/logo-white.png') !important;
  max-height:40px !important; width:auto !important;
}
footer img[src*="/theming/asset/"]{ display:none !important; }

/* FIX #B4 (approved 2026-07-02): learner-dashboard/site-header logo reads small & crowded
   — the app forces the img to height:21px inside a 64px header. Force the horizontal
   lockup to ~38px (natural 200x50 -> ~158x38) and re-center the .logo wrapper with real
   margin. Scoped to .site-header-desktop so the learning-header lockup is unaffected. */
.site-header-desktop .logo{ padding:13px 0 !important; margin-right:22px !important; display:flex !important; align-items:center !important; }
.site-header-desktop .logo img{ height:38px !important; width:auto !important; max-height:none !important; }

/* FIX #6 (batched build, v2 — selector corrected against live DOM 2026-07-02):
   hide the "Discover" nav item in the MFE course header.
   Live DOM: <a href="https://learn.alkemyedtech.com/courses">Discover</a> with NO class,
   inside <div class="nav-course">. (The v1 selector .main-nav a.nav-link[href$="/courses"]
   never matched — the link has no class and isn't under .main-nav.)
   Sibling "My Courses" is href .../dashboard, so [href$="/courses"] hits Discover only. */
.nav-course a[href$="/courses"]{ display:none !important; }
/* FIX #6b (2026-07-02): a SECOND "Discover" (same href .../courses) lives in the user-menu
   dropdown as an <a class="pgn__dropdown-item dropdown-item">, which FIX #6's .nav-course
   scope never reached, so it survived C1 and stayed visible. Live-validated on apps: this
   selector matches EXACTLY ONE anchor (Discover); every other menu item resolves to
   /dashboard, /profile, /account, /logout or # — none end in /courses — so zero collateral. */
a.pgn__dropdown-item[href$="/courses"]{ display:none !important; }
/* FIX #6c (2026-07-06, TRUE class audit): a THIRD "Discover" — labelled "Discover New" —
   survived #6/#6b in the LEARNER-DASHBOARD header (frontend-component-header, the "My Courses"
   page top nav). Live DOM:
     <a class="nav-link" href="https://learn.alkemyedtech.com/courses">Discover New</a>
   inside <nav class="nav main-nav"> > <header class="site-header-desktop">. #6 was scoped to
   .nav-course and #6b to a.pgn__dropdown-item, so neither reached .main-nav .nav-link.
   Full-surface audit (learning / learner-dashboard / account / profile headers + both user
   menus): EVERY Discover instance links to /courses, while the legit siblings resolve to "/"
   ("Courses") and /dashboard ("My Courses"/"Dashboard") — so [href$="/courses"] scoped to
   header/nav containers hits ONLY Discover. IMPORTANT: the learner-dashboard body also has a
   legit "Find a course" CTA (a.pgn__hyperlink inside a .pgn__card) that points to /courses —
   it is OUTSIDE header scope, so this rule leaves it intact. One consolidated set covering all
   three header/menu variants (supersedes #6/#6b, which are kept for defense-in-depth). */
.site-header-desktop a[href$="/courses"],
.site-header-mobile a[href$="/courses"],
.learning-header a[href$="/courses"],
header a[href$="/courses"],
.main-nav a[href$="/courses"],
.nav-course a[href$="/courses"],
a.pgn__dropdown-item[href$="/courses"]{ display:none !important; }

/* FIX #7 (batched build, v2 — specificity corrected against live DOM 2026-07-02):
   "Today" pill on the Dates timeline.
   Live DOM: <span data-testid="dates-badge" class="ml-2 bg-warning-300 text-dark badge badge-primary">.
   The app forces pale green (#d1fae5) via a very high-specificity !important rule
   (div[role=heading].h2 + .list-unstyled... li.dates-day... .badge.badge-primary ≈ specificity 0,11,2).
   The v1 selector (0,2,1) lost. Beat it by repeating the stable [data-testid] attribute 13×
   (specificity 0,13,0 > 0,11,2) — depends only on the testid, robust to DOM structure changes. */
[data-testid="dates-badge"][data-testid="dates-badge"][data-testid="dates-badge"][data-testid="dates-badge"][data-testid="dates-badge"][data-testid="dates-badge"][data-testid="dates-badge"][data-testid="dates-badge"][data-testid="dates-badge"][data-testid="dates-badge"][data-testid="dates-badge"][data-testid="dates-badge"][data-testid="dates-badge"]{
  background-color:#ffd500 !important;
  color:#01357f !important;
  border-color:#ffd500 !important;
}

/* FIX #9 (2026-07-04, approved from before/after mock): soften the learning-MFE content
   cards. They shipped as flat Frost boxes (6px radius, no border, no shadow) and read
   clinical/sharp. Round to 12px + a subtle navy-tinted border + soft shadow for depth.
   Scoped to the course-outline cards and the unit-view outer frame; the navy tray heading
   (B2c), gold active states, and iframe lesson content are untouched. Fonts already render
   Inter throughout at runtime (audited — no system-font leak), so NO font-family change. */
.course-outline-tab .pgn__card, .course-outline-tab .collapsible-card-lg,
.course-outline-tab .raised-card, .course-outline-tab .card{
  border-radius:12px !important;
  border:1px solid rgba(1,53,127,.10) !important;
  box-shadow:0 2px 8px rgba(1,53,127,.07), 0 1px 2px rgba(1,53,127,.04) !important;
}
.course-outline-tab .pgn__card{ margin-bottom:18px !important; }
.course-outline-tab .btn, .course-outline-tab button.btn{ border-radius:9px !important; }
.unit-navigation .btn, .unit-navigation button, .top-unit-navigation .btn{ border-radius:9px !important; }
.sequence-container, .unit-iframe-wrapper{ border-radius:12px !important; }
.unit-iframe-wrapper{
  box-shadow:0 2px 8px rgba(1,53,127,.07), 0 1px 2px rgba(1,53,127,.04) !important;
  border:1px solid rgba(1,53,127,.08) !important; overflow:hidden;
}

/* FIX #10a (2026-07-04, live-validated): brand the keyboard focus ring gold. Paragon sets
   :focus-visible{outline-width:2px} but never sets outline-color, so the UA-default blue
   (rgb(0,95,204)) leaked platform-wide as a barely-visible light-blue ring. Replace with the
   brand gold ring + a navy halo — gold alone on white is <1.5:1 (fails WCAG 2.4.11), the
   navy box-shadow halo restores >=3:1 contrast on both light and navy surfaces, so focus
   stays clearly visible everywhere (buttons, links, tabs, cards, form inputs across MFEs). */
:focus-visible{
  outline:2px solid #ffd500 !important; outline-offset:2px !important;
  box-shadow:0 0 0 4px rgba(1,53,127,.42) !important;
}
/* selected/expanded outline+sidebar section card -> gold left-accent (selection cue) */
.pgn_collapsible.active-section{ border-left:4px solid #ffd500 !important; }

/* FIX #10b (2026-07-04, live-validated): sidebar/outline row hover rendered warm greige
   (#E1DDDB = Paragon light-500) — off-brand beige. Repaint hover with cool Frost #F5F6FA so
   hover, the Frost selected row, and the gold accent read as one coherent system, no beige. */
.collapsible-trigger:hover{ background-color:#F5F6FA !important; }
li.bg-info-100 a:hover, .list-unstyled a.row:hover, .course-outline-tab a.row:hover{
  background-color:#F5F6FA !important;
}
`;
    document.head.appendChild(akStyle);
  }
  // FIX #8 (batched build, v2 — target corrected against live DOM 2026-07-02):
  // remove the course-end archival notice
  // ("After the course ends, the course content will be archived and no longer active.")
  // on the MFE Dates timeline + course-home date widgets.
  // Live DOM: inside <div data-testid="dates-item"> there are TWO children —
  //   <div>…<span class="font-weight-bold">Course ends</span></div>   (the LABEL — KEEP)
  //   <div class="small mb-2">After the course ends… archived…</div>  (the NOTICE — HIDE)
  // The v1 selector `.date-summary-text` did not exist; hiding the whole dates-item (v1.5)
  // also removed the "Course ends" label. Correct scope = the DEEPEST element that contains
  // the sentence (no child element also contains it) — that's the description div only,
  // leaving the label intact. Gated by akStudio so Studio MFEs are untouched (DCE'd out).
  var AK_ARCHIVE_RE = /archived and no longer active/i;
  // FIX #8 (v3, 2026-07-04): v2 scoped the query to [data-testid="dates-item"], which only
  // covered the Dates-page timeline. The course-home right-sidebar "Important dates" widget
  // renders the same sentence in different DOM and survived. Broaden to a document-wide
  // text-match so BOTH surfaces (and any future one) are covered. Cheap gate: bail unless the
  // phrase appears anywhere in body text; only then walk text-bearing leaves. The deepest-match
  // guard is unchanged, so the "Course ends" label stays — we hide only the leaf that owns
  // the sentence, not its container.
  function akHideArchival(){
    if (typeof document === 'undefined' || !document.body) return;
    if (!AK_ARCHIVE_RE.test(document.body.textContent || '')) return;
    var nodes = document.querySelectorAll('div,span,p,li,small,td,dd');
    for (var i = 0; i < nodes.length; i++){
      var n = nodes[i];
      if (n.getAttribute('data-ak-hidden')) continue;
      if (!AK_ARCHIVE_RE.test(n.textContent || '')) continue;
      // only the deepest match: skip if a child element also contains the sentence
      var childMatch = false;
      for (var j = 0; j < n.children.length; j++){
        if (AK_ARCHIVE_RE.test(n.children[j].textContent || '')){ childMatch = true; break; }
      }
      if (childMatch) continue;
      n.style.display = 'none';
      n.setAttribute('data-ak-hidden', '1');
    }
  }
  // FIX #B3: kill the residual Help affordance in MFE headers. In the learning MFE it
  // renders as <a class="text-gray-700 ml-2" href="null">Help</a> (a broken no-op link);
  // other MFE headers have no Help. Robust text-match (class audit) rather than the brittle
  // href="null" selector, scoped to header containers so page-body "Help" text is untouched.
  function akHideHelp(){
    if (typeof document === 'undefined') return;
    var els = document.querySelectorAll('.learning-header a, .learning-header button, header a, header button, .site-header-desktop a, .site-header-desktop button');
    for (var i = 0; i < els.length; i++){
      var e = els[i];
      if (e.getAttribute('data-ak-help-hidden')) continue;
      if ((e.textContent || '').trim().toLowerCase() !== 'help') continue;
      e.style.display = 'none';
      e.setAttribute('data-ak-help-hidden', '1');
    }
  }
  // FIX #6c (JS layer, 2026-07-06): robust text-match hide of "Discover"/"Discover New" across
  // ALL MFE headers — immune to any href variation (the CSS above handles the href-based match,
  // this catches anything whose href isn't exactly /courses). Scoped to header/nav/menu
  // containers so page-body links ("Find a course", course cards) are never touched, and matches
  // ONLY the exact nav labels so "Courses"/"My Courses"/"Dashboard" are left intact.
  function akHideDiscover(){
    if (typeof document === 'undefined') return;
    var els = document.querySelectorAll('.site-header-desktop a, .site-header-mobile a, .learning-header a, header a, .main-nav a, .nav-course a, a.pgn__dropdown-item');
    for (var i = 0; i < els.length; i++){
      var e = els[i];
      if (e.getAttribute('data-ak-discover-hidden')) continue;
      var t = (e.textContent || '').trim().toLowerCase();
      if (t !== 'discover' && t !== 'discover new') continue;
      var item = e.closest('.nav-item') || e;
      item.style.display = 'none';
      e.setAttribute('data-ak-discover-hidden', '1');
    }
  }
  function akRunAll(){ akApply(); if (!akStudio){ akHideArchival(); akHideHelp(); akHideDiscover(); } }
  if (typeof document !== 'undefined' && document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', akRunAll);
  }
  akRunAll();
  // SPA re-renders date summaries on route change; observe and re-hide. Cheap: on each mutation
  // batch it only queries [data-testid="dates-item"] descendants, and data-ak-hidden skips
  // already-processed nodes.
  if (!akStudio && typeof document !== 'undefined' && typeof MutationObserver !== 'undefined') {
    var akObsStart = function(){
      if (!document.body) return;
      new MutationObserver(function(){ akHideArchival(); akHideHelp(); akHideDiscover(); }).observe(document.body, { childList: true, subtree: true });
    };
    if (document.body) akObsStart();
    else document.addEventListener('DOMContentLoaded', akObsStart);
  }
})();
// ===== end Alkemy brand v9 =====


let themeCookie = 'indigo-toggle-dark';
let themeCookieExpiry = 90; // days

const AddDarkTheme = () => {
  const cookies = new Cookies();
  const isThemeToggleEnabled = getConfig().INDIGO_ENABLE_DARK_TOGGLE;

  const getCookieExpiry = () => {
    const today = new Date();
    return new Date(today.getFullYear(), today.getMonth(), today.getDate() + themeCookieExpiry);
  };

  const getCookieOptions = () => {
    const serverURL = new URL(getConfig().LMS_BASE_URL);
    const options = { domain: serverURL.hostname, path: '/', expires: getCookieExpiry() };
    return options;
  };

  const addDarkThemeToIframes = () => {
    const iframes = document.getElementsByTagName('iframe');
    const iframesLength = iframes.length;
    if (iframesLength > 0) {
      Array.from({ length: iframesLength }).forEach((_, index) => {
        const style = document.createElement('style');
        style.textContent = `
          body{
            background-color: #0D0D0E;
            color: #ccc;
          }
          a {color: #ccc;}
          a:hover{color: #d3d3d3;}
          `;
        if (iframes[index].contentDocument) { iframes[index].contentDocument.head.appendChild(style); }
      });
    }
  };

  useEffect(() => {
    const theme = cookies.get(themeCookie);

    // - When page loads, Footer loads before MFE content. Since there is no iframe on page,
    // it does not append any class. MutationObserver observes changes in DOM and hence appends dark
    // attributes when iframe is added. After 15 sec, this observer is destroyed to conserve resources. 
    // - It has been added outside dark-theme condition so that it can be removed on Component Unmount.
    // - Observer can be passed to `addDarkThemeToIframes` function and disconnected after observing Iframe.
    // This approach has a limitation: the observer first detects the iframe and then detects the docSrc. 
    // We need to wait for docSrc to fully load before appending the style tag.
    const observer = new MutationObserver(() => {
      addDarkThemeToIframes();
    });

    if (isThemeToggleEnabled && theme === 'dark') {
      document.body.classList.add('indigo-dark-theme');
      
      observer.observe(document.body, { childList: true, subtree: true });
      setTimeout(() => observer?.disconnect(), 15000); // clear after 15 sec to avoid resource usage

      cookies.set(themeCookie, theme, getCookieOptions());      //  on page load, update expiry
    }

    return () => observer?.disconnect();
  }, []);

  return (<div />);
};

async function setConfig () {
  let config = {
    pluginSlots: {}
  };

  try {
    /* We can't assume FPF exists, as it's not declared as a dependency in all
     * MFEs, so we import it dynamically. In addition, for dynamic imports to
     * work with Webpack all of the code that actually uses the imported module
     * needs to be inside the `try{}` block.
     */
    const { DIRECT_PLUGIN, PLUGIN_OPERATIONS } = await import('@openedx/frontend-plugin-framework');
    if (process.env.APP_ID == 'authn') {
    }
    if (process.env.APP_ID == 'authoring') {
    }
    if (process.env.APP_ID == 'account') {
const { default: IndigoFooter } = await import('@edly-io/indigo-frontend-component-footer');
      addPlugins(config, 'footer_slot', [ 
            {
                op: PLUGIN_OPERATIONS.Hide,
                widgetId: 'default_contents',
            },
            {
                op: PLUGIN_OPERATIONS.Insert,
                widget: {
                    id: 'default_contents',
                    type: DIRECT_PLUGIN,
                    priority: 1,
                    RenderWidget: <IndigoFooter />,
                },
            },
            {
                op: PLUGIN_OPERATIONS.Insert,
                widget: {
                    id: 'read_theme_cookie',
                    type: DIRECT_PLUGIN,
                    priority: 2,
                    RenderWidget: AddDarkTheme,
                },
            },
  ]);
    }
    if (process.env.APP_ID == 'communications') {
    }
    if (process.env.APP_ID == 'discussions') {
const { default: IndigoFooter } = await import('@edly-io/indigo-frontend-component-footer');
      addPlugins(config, 'footer_slot', [ 
            {
                op: PLUGIN_OPERATIONS.Hide,
                widgetId: 'default_contents',
            },
            {
                op: PLUGIN_OPERATIONS.Insert,
                widget: {
                    id: 'default_contents',
                    type: DIRECT_PLUGIN,
                    priority: 1,
                    RenderWidget: <IndigoFooter />,
                },
            },
            {
                op: PLUGIN_OPERATIONS.Insert,
                widget: {
                    id: 'read_theme_cookie',
                    type: DIRECT_PLUGIN,
                    priority: 2,
                    RenderWidget: AddDarkTheme,
                },
            },
  ]);
    }
    if (process.env.APP_ID == 'gradebook') {
    }
    if (process.env.APP_ID == 'learner-dashboard') {
const { default: IndigoFooter } = await import('@edly-io/indigo-frontend-component-footer');
      addPlugins(config, 'footer_slot', [ 
            {
                op: PLUGIN_OPERATIONS.Hide,
                widgetId: 'default_contents',
            },
            {
                op: PLUGIN_OPERATIONS.Insert,
                widget: {
                    id: 'default_contents',
                    type: DIRECT_PLUGIN,
                    priority: 1,
                    RenderWidget: <IndigoFooter />,
                },
            },
            {
                op: PLUGIN_OPERATIONS.Insert,
                widget: {
                    id: 'read_theme_cookie',
                    type: DIRECT_PLUGIN,
                    priority: 2,
                    RenderWidget: AddDarkTheme,
                },
            },
  ]);
    }
    if (process.env.APP_ID == 'learning') {
const { default: IndigoFooter } = await import('@edly-io/indigo-frontend-component-footer');
      addPlugins(config, 'footer_slot', [ 
            {
                op: PLUGIN_OPERATIONS.Hide,
                widgetId: 'default_contents',
            },
            {
                op: PLUGIN_OPERATIONS.Insert,
                widget: {
                    id: 'default_contents',
                    type: DIRECT_PLUGIN,
                    priority: 1,
                    RenderWidget: <IndigoFooter />,
                },
            },
            {
                op: PLUGIN_OPERATIONS.Insert,
                widget: {
                    id: 'read_theme_cookie',
                    type: DIRECT_PLUGIN,
                    priority: 2,
                    RenderWidget: AddDarkTheme,
                },
            },
  ]);
    }
    if (process.env.APP_ID == 'ora-grading') {
    }
    if (process.env.APP_ID == 'profile') {
const { default: IndigoFooter } = await import('@edly-io/indigo-frontend-component-footer');
      addPlugins(config, 'footer_slot', [ 
            {
                op: PLUGIN_OPERATIONS.Hide,
                widgetId: 'default_contents',
            },
            {
                op: PLUGIN_OPERATIONS.Insert,
                widget: {
                    id: 'default_contents',
                    type: DIRECT_PLUGIN,
                    priority: 1,
                    RenderWidget: <IndigoFooter />,
                },
            },
            {
                op: PLUGIN_OPERATIONS.Insert,
                widget: {
                    id: 'read_theme_cookie',
                    type: DIRECT_PLUGIN,
                    priority: 2,
                    RenderWidget: AddDarkTheme,
                },
            },
  ]);
    }
  } catch (err) { console.error("env.config.jsx failed to apply: ", err);}

  return config;
}

export default setConfig;